import { Icon } from '@ab-core/icon';
import {
    SCALABLE_PRODUCT_CARD_TYPE,
    ScalableProductCard,
    scalableStyle
} from '@ab-core/scalable-product-card';
import { getTestIdProp } from '@ab-core/testing';
import type { FC } from 'react';
import React, { useState } from 'react';
import type { AccessoryProduct } from '../hooks/useAddedToCartAccessoriesProductList';
import { AccessoriesTabWrapper, ArrowButton, ProductGrid, IconContainer } from './style';
import { AccessoryCrossSellingProvider } from '../context/accessoryCrossSelling';

type CrossSellingAccessoriesContainerProps = {
    products: Array<AccessoryProduct>;
    onClose?: () => void;
};

const PRODUCTS_PER_PAGE = 4;

export const CrossSellingAccessoriesContainer: FC<CrossSellingAccessoriesContainerProps> = ({ products, onClose }) => {
    const [page, setPage] = useState(0);

    const pageCount = Math.max(1, Math.ceil(products.length / PRODUCTS_PER_PAGE));
    const currentPage = Math.min(page, pageCount - 1);
    const start = currentPage * PRODUCTS_PER_PAGE;
    const visibleProducts = products.slice(start, start + PRODUCTS_PER_PAGE);

    return (
        <AccessoriesTabWrapper {...getTestIdProp('crosselling-accessories')}>
            <ArrowButton
                type="button"
                disabled={currentPage === 0}
                onClick={() => setPage(currentPage - 1)}
                {...getTestIdProp('crosselling-accessories-prev')}
            >
                <Icon name="ChevronLeft" color="white" />
            </ArrowButton>
            {onClose && (
                <IconContainer onClick={onClose} {...getTestIdProp('close-crosselling-accessories-button')}>
                    <Icon name="Close" />
                </IconContainer>
            )}

            <AccessoryCrossSellingProvider>
                <ProductGrid>
                    {visibleProducts.map((product) => (
                        <ScalableProductCard
                            key={product.sku}
                            cardType={SCALABLE_PRODUCT_CARD_TYPE.MOBILE}
                            scalableStyle={scalableStyle.presets.crosssellingAccessoriesCard}
                            product={product}
                        />
                    ))}
                </ProductGrid>
            </AccessoryCrossSellingProvider>
            <ArrowButton
                type="button"
                disabled={currentPage >= pageCount - 1}
                onClick={() => setPage(currentPage + 1)}
                {...getTestIdProp('crosselling-accessories-next')}
            >
                <Icon name="ChevronRight" color="white" />
            </ArrowButton>
        </AccessoriesTabWrapper>
    );
};
